import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { SwiperClass } from "core/classes/swiper/swiper.class";
import {
  AttachmentsView,
  AttachmentsViewOptions
} from "core/classes/attachments/attachments.view.class";
import { MediaQueryPublisher } from "core/classes/media.query.publisher.class";

let StoryGalleryOptions = {
  caption: ".caption",
  activeCaption: ".swiper-slide-active .caption",
  toggleCaption: ".toggle-caption",
  toggle: "hide",
  gallery: ".galleryItems",
  scroller: ".storyScroller",
  activeScrollerClass: "active",
  counter: ".current-index",
  buttons: {
    container: ".controls",
    next: ".controls li.next",
    previous: ".controls li.previous",
    roundLengths: true
  },
  preloadMedia: true
};

let AttachmentsGalleryOptions = function() {
  return $.extend({}, AttachmentsViewOptions, {
    controlsHTML:
      "<div class='controls toolbar galleryControls'><ul><li class='previous'><a href='#'>Previous slide</a></li><li class='next'><a href='#'>Next slide</a></li></ul></div>",
    attachmentClasses: {
      gallery: ".gallery-attachments"
    },
    initialSlideTimeout: 2000,
    swiper: {
      noSwiping: true
    },
    roundLengths: true
  });
};

class StoryGallery extends Class {
  constructor(gallery, options) {
    super();
    this.element = $(gallery);
    this.mediator = $({});
    this.setOptions(AttachmentsGalleryOptions(), StoryGalleryOptions, options);
    this.swiper = new SwiperClass(this.element, this.mediator, {
      swiperContainer: this.options.gallery
    });
    this.swiperEvents();
    this.captionToggle = this.element.find(this.options.toggleCaption);
    this.setupEvents();
    this.testCaptionControlDisplay();
    this.addMaxHeight();
    this.makeCaptionsUnfocusable();
  }

  setupEvents() {
    var self = this;

    this.captionToggle.on("click", function(event) {
      event.preventDefault();
      self.toggleCaption();
      self.testCaptionControlDisplay();
    });

    if (this.element[0].dataset.galleryCaption === "show") {
      this.captionToggle.trigger("click");
    }

    this.element.find(this.options.buttons.next).on("click", function(event) {
      event.preventDefault();
      self.swiper.next();
      self.testCaptionControlDisplay();
    });

    this.element
      .find(this.options.buttons.previous)
      .on("click", function(event) {
        event.preventDefault();
        self.swiper.previous();
        self.testCaptionControlDisplay();
      });

    this.swiper.swiper.on("TouchEnd", function(swiper) {
      self.testCaptionControlDisplay();
    });

    $(window).on("resize", function() {
      self.addMaxHeight();
    });
  }

  swiperEvents() {
    var self = this;

    this.swiper.swiper.on("slideChangeTransitionStart", function() {
      var index = this.activeIndex;
      self.swiper.preload();
      self.updateFullscreenButton(index);
      self.updateCounter();
      self.checkButtons();
    });
  }

  testCaptionControlDisplay() {
    const currentSlideHasCaption = this.element
      .find(this.options.gallery)
      .find(".swiper-slide-active .caption").length;
    const captionIsShowing = this.checkToggleCaption();
    this.makeCaptionsUnfocusable();
    if (captionIsShowing) {
      this.makeActiveCaptionFocusable();
    }
    if (currentSlideHasCaption) {
      this.showCaptionControl();
    } else {
      this.hideCaptionControl();
    }
  }

  checkToggleCaption() {
    return this.captionToggle.hasClass("hide");
  }

  showCaptionControl() {
    this.captionToggle.addClass("show");
  }

  hideCaptionControl() {
    this.captionToggle.removeClass("show");
  }

  makeCaptionsUnfocusable() {
    this.element
      .find(this.options.caption)
      .find(".source a")
      .attr("tabindex", "-1");
  }

  makeActiveCaptionFocusable() {
    this.element
      .find(this.options.activeCaption)
      .find(".source a")
      .attr("tabindex", "0");
  }

  checkButtons() {
    this.checkStart = this.swiper.swiper.activeIndex <= 0 ? true : false;
    this.checkEnd =
      this.swiper.swiper.activeIndex >= this.swiper.swiper.slides.length - 1
        ? true
        : false;
    this.checkStart
      ? this.element.find(this.options.buttons.previous).addClass("disabled")
      : this.element
          .find(this.options.buttons.previous)
          .removeClass("disabled");
    this.checkEnd
      ? this.element.find(this.options.buttons.next).addClass("disabled")
      : this.element.find(this.options.buttons.next).removeClass("disabled");
  }

  updateCounter() {
    this.element
      .find(this.options.counter)
      .text(this.swiper.getActiveIndex() + 1);
  }

  updateFullscreenButton(index) {
    this.element
      .find("button")
      .attr("data-url", $($(this.swiper.getSwiperSlides())[index]).data("url"));
  }

  toggleCaption() {
    $(this.swiper.getSwiperSlides())
      .find(this.options.caption)
      .toggleClass(this.options.toggle);
    this.captionToggle.toggleClass(this.options.toggle);
    this.updateCaptionLink();
  }

  updateCaptionLink() {
    this.captionToggle.hasClass(this.options.toggle)
      ? this.captionToggle.text(Abacus.Lang.core.caption.show)
      : this.captionToggle.text(Abacus.Lang.core.caption.hide);
  }

  addMaxHeight() {
    var galleryImages = this.element.find(".swiper-wrapper");
    galleryImages.find("img").css("max-height", galleryImages.height());
  }
}

export { StoryGallery };



// WEBPACK FOOTER //
// ./Javascript/core/classes/galleries/gallery.story.class.js